import InstallmentsPlanTable from './InstallmentsPlanTable';

export default InstallmentsPlanTable;
